// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
// import vuexI18n from 'vuex-i18n';
import { sync } from 'vuex-router-sync';
import App from './App';
import router from './router';
import store from './store';

require('babel-polyfill');

sync(store, router);

Vue.config.productionTip = false;

// Vue.use(vuexI18n.plugin, store);

// const translationsEn = {
//   menuCTA: 'Menu',
//   printCTA: 'Printable PDF',
//   prev: 'Previous',
//   next: 'Next',
//   backcoverTitle: 'Committed to sustainable productivity',
//   backcoverText: 'We stand by our responsibilities towards our customers, towards the<br>environment and the people around us. We make performance stand<br>the test of time. This is what we call – Sustainable Productivity.',
//   productTitle: 'Product',
//   threesixtyLabels: 'Labels',
//   threesixtyCanopy: 'Canopy',
// };

// Vue.i18n.add('en', translationsEn);
// Vue.i18n.set('en');

const detectIE = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  if (msie > 0) { // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  const trident = ua.indexOf('Trident/');
  if (trident > 0) { // IE 11 => return version number
    const rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  const edge = ua.indexOf('Edge/');
  if (edge > 0) { // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
};

if (detectIE()) {
  document.body.classList.add('ie');
} else {
  document.body.classList.add('no-ie');
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js